import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

export const getMaximumWebcastDuration = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled, value }) => name === 'maxCommunicationDuration' && enabled === true)
  if (!enabledFeature) {

    const disabledFeature = channelData.features.find(({ name, enabled }) => name === 'maxCommunicationDuration' && enabled === false)

    if (disabledFeature) {

        return ''

    } else {

        return false

    }

  }

  // Getting value in seconds, converting it to minutes
  let duration = !isEmpty(enabledFeature.value) && enabledFeature.value > 0 ?  String(enabledFeature.value / 60) : enabledFeature.value

  return duration

}
